import DqTariffspanel from './src/tariffspanel'

/* istanbul ignore next */
DqTariffspanel.install = function (Vue) {
  Vue.component(DqTariffspanel.name, DqTariffspanel)
}

export default DqTariffspanel



// WEBPACK FOOTER //
// ./src/dq-ui/packages/tariffspanel/tariffspanel.js